import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import * as Icons from "lucide-react";

/** Scroll-triggered reveal wrapper */
export const Reveal = ({ children, className = "", delay = 0, as: Tag = "div" }) => {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setShown(true);
            io.disconnect();
          }
        });
      },
      { threshold: 0.12 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return (
    <Tag ref={ref} className={`reveal ${shown ? "is-visible" : ""} ${className}`} style={{ transitionDelay: `${delay}ms` }}>
      {children}
    </Tag>
  );
};

export const SectionTitle = ({ children, sub, light = false, className = "" }) => (
  <div className={`text-center mb-10 ${className}`}>
    <h2 className={`section-title ${light ? "text-white" : ""}`}>{children}</h2>
    {sub && <p className={`mt-3 max-w-2xl mx-auto text-[15px] leading-7 ${light ? "text-white/90" : "text-[#58595b]"}`}>{sub}</p>}
  </div>
);

export const OutlineButton = ({ to, children, className = "", ...rest }) => (
  <Link to={to} className={`btn-outline ${className}`} {...rest}>
    {children} <ChevronRight size={16} />
  </Link>
);

export const LucideIcon = ({ name, size = 26, className = "" }) => {
  const Cmp = Icons[name] || Icons.Circle;
  return <Cmp size={size} className={className} />;
};

/** Inner page banner with breadcrumb */
export const PageBanner = ({ title, subtitle, image, crumbs = [] }) => (
  <section className="page-banner" data-testid="page-banner">
    <img src={image} alt="" className="page-banner__img" />
    <div className="page-banner__overlay" />
    <div className="container-dic relative z-10 h-full flex flex-col justify-center">
      <nav className="text-[12px] tracking-wide text-white/85 mb-3 flex items-center gap-2" aria-label="Breadcrumb">
        <Link to="/" className="hover:text-white">Home</Link>
        {crumbs.map((c) => (
          <React.Fragment key={c}>
            <ChevronRight size={12} />
            <span className="text-white">{c}</span>
          </React.Fragment>
        ))}
      </nav>
      <h1 className="text-white text-[34px] md:text-[46px] font-bold leading-tight">{title}</h1>
      {subtitle && <p className="text-white/90 text-[15px] md:text-[17px] mt-2 max-w-2xl">{subtitle}</p>}
    </div>
  </section>
);
